import React from 'react'
import { Link } from 'react-router-dom'
import Styles from "../css/Navbar.module.css"

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg">
    <div className="container-fluid">
        <Link className="navbar-brand" style={{fontFamily:"cursive", fontWeight:"bold"}} to="/">Giga Chat</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
        <ul className="navbar-nav">
            <li className="nav-item">
            
            </li>
        </ul>
        </div>
    </div>
    </nav>
  )
}
